<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<a id="page_iii"></a>
<h1 class="title">The First Enigma Code-Breaker</h1>
<p class="title1">The Untold Story of Marian Rejewski who passed the baton to Alan Turing</p>
<p class="author1">Robert Gawłowski</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?b92144fc